import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR} from '@angular/forms';
@Component({
    selector: 'input-switch',
    templateUrl: 'input-switch.html',
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => InputSwitchComponent),
        multi: true
    }]
})
export class InputSwitchComponent {
    check: any;
    @Input()
    available:boolean=false;
    @Input()
    value:number;
    @Input()
    element:any;
    @Input()
    name:string;
    @Output()
    witch: EventEmitter<boolean> = new EventEmitter<boolean>();
    _onChange = (_: any) => { };
    _onTouched = () => { };

    writeValue(value: any): void {
        this.check = value;
        this._onChange(value);
    }

    registerOnChange(fn: (_: any) => {}): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this._onTouched = fn;
    }

    /**
     * Utility method to get values from
     * selected items
     * @returns {boolean}
     */
    private getValues(): boolean {
        return this.check;
    }

    change(){
        this.writeValue(this.getValues());
    }
    onWitch(){
        this.witch.emit(true);
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/input-switch/input-switch.ts